import {BI_ORIGINS} from '@wix/wix-events-commons-statics'
import React from 'react'
import {useAppActions, useAppSelector} from '../../../../../hooks/runtime'
import {getShowDescriptionPlace, isInAccessibilityMode, isInDescription} from '../../../../../selectors/seating/mode'
import {getPlacesInBasket, getPlacesInBasketCount} from '../../../../../selectors/seating/places'
import {AccessibilityMode} from '../../accessibility-mode'
import {TicketDescription} from '../../ticket-description'
import {Tickets} from '../../tickets'
import {SidebarProps} from './interfaces'
import s from './sidebar.scss'

export const Sidebar = ({
  onRemoveClick,
  onCheckoutClick,
  setForcedPopoverPlanPlaceId,
  selectSeatForDescription,
  setAccessibilityToast,
}: SidebarProps) => {
  const {clickPlace} = useAppActions()

  const showAccessibilityMode = useAppSelector(isInAccessibilityMode)
  const placesInBasketCount = useAppSelector(getPlacesInBasketCount)
  const placesInBasket = useAppSelector(getPlacesInBasket)
  const showSeatDescription = useAppSelector(isInDescription)
  const descriptionPlace = useAppSelector(getShowDescriptionPlace)

  return (
    <div className={s.sidebar}>
      <Tickets
        placesInBasketCount={placesInBasketCount}
        placesInBasket={placesInBasket}
        show={!showAccessibilityMode && !showSeatDescription}
        onRemoveClick={onRemoveClick}
        onCheckoutClick={onCheckoutClick}
        onTicketMoreInfoClick={selectSeatForDescription}
        setForcedPopoverPlanPlaceId={setForcedPopoverPlanPlaceId}
      />
      <AccessibilityMode
        setForcedPopoverPlanPlaceId={setForcedPopoverPlanPlaceId}
        setAccessibilityToast={setAccessibilityToast}
      />
      <TicketDescription
        showAccessibilityMode={showAccessibilityMode}
        onTicketClick={() =>
          clickPlace({
            place: descriptionPlace,
            origin: BI_ORIGINS.SEATINGS_MODAL_TICKET_DESCRIPTION,
            updateShownDescription: true,
          })
        }
        place={descriptionPlace}
        show={showSeatDescription}
        onClose={() => selectSeatForDescription(null)}
      />
    </div>
  )
}
